import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const TOS_ASSET_NAME = 'terms-of-service';
export const PRIVACY_POLICY_ASSET_NAME = 'privacy-policy';
export const PROVIDER_TOS_ASSET_NAME = 'service-provider-terms-of-service';
export const PROVIDER_PRIVACY_POLICY_ASSET_NAME = 'service-provider-privacy-policy';

export const loadData = (params, search) => dispatch => {
  const pageAsset = {
    termsOfService: `content/pages/${TOS_ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${PRIVACY_POLICY_ASSET_NAME}.json`,
    serviceProviderTermsOfService: `content/pages/${PROVIDER_TOS_ASSET_NAME}.json`,
    serviceProviderPrivacyPolicy: `content/pages/${PROVIDER_PRIVACY_POLICY_ASSET_NAME}.json`,
  };
  return dispatch(fetchPageAssets(pageAsset, true));
};
